import getApi from '../../api/apisauceConfig'
import { LegalDocument } from '../../model/LegalDocument'

export const readLegalDocument = (type: string) =>
  getApi().post<LegalDocument>(`legal_documents/${type}/read`)
